 export enum DateFilter {
    TODAY = "Today",
    THIS_WEEK = "This Week",
    LAST_WEEK = "Last Week",
    THIS_MONTH = "This Month",
    LAST_MONTH = "Last Month",
    LAST_3_MONTHS = "Last 3 Months",
}